import React from 'react';

const SmallPlusIcon = props => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' {...props}>
            <g fill='#FFF' fillRule='evenodd'>
                <path d='M11.294 8.471L4.706 8.471 4.706 7.529 11.294 7.529z' />
                <path d='M11.294 8.471L4.706 8.471 4.706 7.529 11.294 7.529z' transform='rotate(90 8 8)' />
            </g>
        </svg>
    );
};

export default SmallPlusIcon;
